import { z } from 'zod';

import { zodCallOffAttachmentChangeSchema } from '~/data/callOff/validations';
import { HISTORY_ACTORS } from '~/data/contract';

// Changed fields schema (key-value pairs with old/new values)
// Note: API returns snake_case but it's auto-converted to camelCase
export const zodChangedFieldsSchema = z
  .record(
    z.string(),
    z.object({
      new: z.unknown().nullish(),
      old: z.unknown().nullish(),
    }),
  )
  .nullish();

// Item changes schema (camelCase after auto-conversion)
export const zodItemChangeSchema = z.object({
  articleNr: z.string().nullish(),
  changedFields: zodChangedFieldsSchema,
  changeType: z.string().nullish(),
  itemId: z.string().nullish(),
});

// Proposed changes schema (for negotiation actions)
export const zodProposedChangesDataSchema = z
  .object({
    deliveryDateFrom: z.iso.date().nullish(),
    deliveryDateUntil: z.iso.date().nullish(),
    deliveryTimeFrom: z.string().nullish(),
    deliveryTimeUntil: z.string().nullish(),
    items: z
      .array(
        z.object({
          calloffItemId: z.string(),
          quantity: z.union([z.number(), z.string()]),
        }),
      )
      .nullish(),
  })
  .nullish();

// History entry schema
export const zodCallOffHistoryEntrySchema = z.object({
  action: z.string(),
  actor: z.enum(HISTORY_ACTORS),
  actorDisplay: z.string(),
  attachmentChanges: z.array(zodCallOffAttachmentChangeSchema).nullish(),
  changedFields: zodChangedFieldsSchema,
  createdAt: z.string(),
  itemChanges: z.array(zodItemChangeSchema).nullish(),
  notes: z.string().nullish(),
  previousStatus: z.string().nullish(),
  proposed: zodProposedChangesDataSchema,
  snapshot: z.unknown(),
  status: z.string(),
  versionNumber: z.number(),
});

// Response schema for call-off history (paginated)
export const zodCallOffHistoryResponseSchema = z.object({
  calloffId: z.string(),
  data: z.array(zodCallOffHistoryEntrySchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative().nullable(),
});
